import authenticationEventVersionsMapper from './authenticationEventVersionsMapper.js'
import dealerStockClickedEventVersionsMapper from './dealerStockClickedEventVersionsMapper.js'
import defaultEventVersionsMapper from './defaultEventVersionsMapper.js'

const eventVersionsMappers = {
  dealerStockClickedEventVersionsMapper,
  defaultEventVersionsMapper,
  authenticationEventVersionsMapper
}

export default eventVersionsMappers
